<template>
    <div>
        <loading
            :active.sync="loadingContentProduct"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                    <!-- <router-link :to="{name:'home'}" class="headerButton"> -->
                    <ion-icon name="chevron-back-outline"></ion-icon>
                    <!-- </router-link> -->
                </a>
            </div>
            <div class="pageTitle">{{ title }}</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <div class="form-group boxed">
                        <label
                            class="label"
                            v-if="product_data.label_input == null"
                            >No. Pelanggan</label
                        >
                        <label class="label" v-else>{{
                            product_data.label_input
                        }}</label>
                        <input
                            type="tel"
                            class="form-control form-control-lg"
                            v-if="product_data.type_input == 'NUMBER'"
                            v-model="data_form.no_pelanggan"
                            @input="clearData"
                        />
                        <input
                            type="text"
                            class="form-control form-control-lg"
                            v-else
                            v-model="data_form.no_pelanggan"
                            @input="clearData"
                        />
                        <div class="mt-2">
                            <div
                                class="chip chip-media"
                                style="font-size: 11px; background: #efefef"
                                @click="openPhoneBook()"
                            >
                                <i class="chip-icon bg-primary">
                                    <ion-icon name="journal-outline"></ion-icon>
                                </i>
                                <span class="chip-label"
                                    >Ambil dari Kontak</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ul class="listview image-listview inset mt-1">
                <li>
                    <div class="item">
                        <!-- <img src="assets/img/sample/avatar/avatar1.jpg" alt="image" class="image"> -->
                        <div class="image-overflow">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-3.png')"
                                :data-src="
                                    VUE_ENV.VUE_APP_ASSET_URL +
                                    '/img/icon/operator/' +
                                    product_data.icon
                                "
                                alt="image"
                                class="image"
                            />
                        </div>
                        <div class="in">
                            <div>
                                <b>{{ product_data.product_name }}</b>
                                <footer
                                    v-if="product_data.description != undefined"
                                >
                                    {{ product_data.description }}
                                </footer>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="section inset mt-1">
                <div
                    class="wide-block pt-2 pb-2"
                    v-if="product_data.status_biaya_outlet"
                >
                    <div class="form-group boxed">
                        <label class="label">Biaya Outlet</label>
                        <select
                            class="form-control custom-select"
                            v-model="data_form.outlet"
                            @change="clearData"
                        >
                            <option value="0">Rp 0</option>
                            <option value="500">Rp 500</option>
                            <option value="1000">Rp 1.000</option>
                            <option value="2000">Rp 2.000</option>
                            <option value="2500">Rp 2.500</option>
                            <option value="3000">Rp 3.000</option>
                            <option value="4000">Rp 4.000</option>
                            <option value="5000">Rp 5.000</option>
                            <option value="7000">Rp 7.000</option>
                            <option value="10000">Rp 10.000</option>
                            <option value="15000">Rp 15.000</option>
                        </select>
                        <div class="input-info mt-1" style="line-height: 1rem">
                            Biaya outlet adalah biaya tambahan yang dapat kamu
                            tentukan sendiri yang dimana akan menjadi keuntungan
                            langsung untuk kamu diluar dari fee yang telah
                            diberikan.
                        </div>
                    </div>
                </div>
                <div class="form-group basic mt-1" v-if="!detail_tagihan">
                    <button
                        class="btn btn-primary btn-block"
                        @click="checkbill(product_data.id)"
                    >
                        Cek Tagihan
                    </button>
                </div>
            </div>
            <!-- <div class="section inset mt-1" v-if="product.length > 10 && !detail_tagihan">
                <div class="wide-block pt-2 pb-2">
                    <div class="form-group basic">
                        <div class="input-group">
                            <span class="input-group-text"><ion-icon name="search-outline"></ion-icon></span>
                            <input type="text" class="form-control" placeholder="Cari Produk" v-model="keywords">
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="form-button-group mx-width shadow-header-footer" v-if="!detail_tagihan" >
                <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary btn-block btn-lg'" @click.native="checkbill(product_data.id)">Cek Tagihan</ButtonLoader>
            </div> -->
            <!-- <div class="section full mt-1" v-if="product.length > 0 && !detail_tagihan">
                <div v-if="loadingContentProduct == false">
                    <div v-if="product.length > 0">
                        <ul class="listview image-listview-product inset">
                            <li v-for="item in filterProduct(product)" :key="item.id">
                                <a class="item pl-3 pr-3" @click="checkbill(item.id)">
                                    <div class="in">
                                        <div style="width: 90%;">
                                            <h4>{{ item.product_name }}</h4>
                                        </div>
                                        <span class="text-muted">
                                            <div class="chip chip-primary ml-05 mb-05">
                                                <span class="chip-label">Cek Tagihan</span>
                                            </div>
                                        </span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <div class="section inset mt-1" v-if="detail_tagihan">
                <div class="wide-block pt-2 pb-2">
                    <blockquote class="blockquote p-1 mb-1">
                        <p class="mb-0"><small>Informasi Tagihan</small></p>
                    </blockquote>
                    <table style="font-size: 12px">
                        <tr>
                            <td width="130px">No. Pelanggan</td>
                            <td width="20px">:</td>
                            <td>{{ data_form.no_pelanggan }}</td>
                        </tr>
                        <tr>
                            <td width="130px">Nama</td>
                            <td width="20px">:</td>
                            <td>{{ data_detail.nama_pelanggan }}</td>
                        </tr>
                        <tr>
                            <td width="130px">Periode</td>
                            <td width="20px">:</td>
                            <td>{{ data_detail.bill_periode }} Bulan</td>
                        </tr>
                        <tr>
                            <td width="130px">Jumlah Tagihan</td>
                            <td width="20px">:</td>
                            <td>Rp {{ data_detail.bill_tagihan | rupiah }}</td>
                        </tr>
                        <tr>
                            <td width="130px">Admin Bank</td>
                            <td width="20px">:</td>
                            <td>Rp {{ data_detail.bill_admin | rupiah }}</td>
                        </tr>
                        <tr v-if="product_data.status_biaya_outlet">
                            <td width="130px">Biaya Outlet</td>
                            <td width="20px">:</td>
                            <td>Rp {{ data_detail.biaya_outlet | rupiah }}</td>
                        </tr>
                        <tr>
                            <td width="130px">Total Tagihan</td>
                            <td width="20px">:</td>
                            <td>
                                <b
                                    >Rp
                                    {{ data_detail.jumlah_bayar | rupiah }}</b
                                >
                            </td>
                        </tr>
                    </table>

                    <hr style="border: 2px dashed grey" />
                    <table
                        style="font-size: 12px"
                        v-if="detail_tagihan && data_detail.bill_detail != ''"
                    >
                        <tr
                            v-for="(item, index) in data_detail.bill_detail"
                            :key="index"
                        >
                            <td width="130px">{{ item.key }}</td>
                            <td width="20px">:</td>
                            <td>{{ item.value }}</td>
                        </tr>
                    </table>

                    <hr
                        style="border: 2px dashed grey"
                        v-if="detail_tagihan && data_detail.bill_detail != ''"
                    />
                    <table style="font-size: 12px">
                        <tr>
                            <td width="130px">Fee / Bonus</td>
                            <td width="20px">:</td>
                            <td>Rp {{ data_detail.bill_fee | rupiah }}</td>
                        </tr>
                        <tr>
                            <td width="130px">Saldo Terpotong</td>
                            <td width="20px">:</td>
                            <td>
                                <b
                                    >Rp
                                    {{
                                        data_detail.bill_total_bayar | rupiah
                                    }}</b
                                >
                            </td>
                        </tr>
                        <tr>
                            <td width="130px">Profit Penjualan</td>
                            <td width="20px">:</td>
                            <td>
                                <b class="text-success"
                                    >Rp
                                    {{
                                        (data_detail.bill_fee +
                                            data_detail.biaya_outlet)
                                            | rupiah
                                    }}</b
                                >
                            </td>
                        </tr>
                    </table>

                    <div class="row mt-2">
                        <div class="col-6">
                            <button
                                class="btn btn-secondary btn-block"
                                @click="clearData"
                            >
                                Batal
                            </button>
                        </div>
                        <div class="col-6">
                            <button
                                class="btn btn-primary btn-block"
                                @click="confirmation"
                            >
                                Bayar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <action-sheet
            ref="confirmation"
            :title="'Konfirmasi Pembayaran'"
            :inset="true"
        >
            <div class="form-group boxed" v-if="customer.pin_trx == 'ENABLED'">
                <label class="label">Masukkan PIN</label>
                <input
                    type="number"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    class="form-control form-control-lg text-center p-0 input-password"
                    style="letter-spacing: 0.7em"
                    maxlength="6"
                    v-model="data_form.pin"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                />
            </div>
            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-secondary btn-block btn-lg"
                            @click="hideConfirm"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            @click.native="submit()"
                            >Bayar</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </action-sheet>

        <action-sheet ref="status" :title="'Status Pembelian'" :inset="true">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Sedang diproses</h3>
                <p>Pembelian Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="status('hide')"
                >
                    Tutup
                </button>
            </div>
        </action-sheet>

        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../api.js';
    import { mapState } from 'vuex';
    export default {
        props: ['title', 'product_data'],
        data() {
            return {
                loadingButton: false,
                loadingContentProduct: true,
                detail_tagihan: false,
                countInquiry: 0,
                status_biaya_outlet: 1,
                product: [],
                data_form: {
                    product_id: '',
                    no_pelanggan: '',
                    outlet: '0',
                    pin: '',
                },
                data_detail: {
                    invoice: '',
                    nama_pelanggan: '',
                    bill_periode: '',
                    bill_tagihan: '',
                    bill_admin: '',
                    bill_total_tagihan: '',
                    bill_fee: '',
                    bill_total_bayar: '',
                    bill_detail: '',
                    biaya_outlet: '',
                    jumlah_bayar: '',
                },
                keywords: '',
                time: null,
            };
        },
        created() {
            // // window.fbq("track", "ViewContent");
            setTimeout(() => (this.loadingContentProduct = false), 500);
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV']),
        },
        methods: {
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            filterProduct: function (product) {
                var app = this;
                return product.filter(function (item) {
                    let regex = new RegExp('(' + app.keywords + ')', 'i');
                    return item.product_name.match(regex);
                });
            },
            clearData() {
                this.$store.commit('RESET_TOAST');
                this.detail_tagihan = false;
                (this.data_form = {
                    product_id: '',
                    no_pelanggan: this.data_form.no_pelanggan,
                    outlet: this.data_form.outlet,
                    pin: '',
                }),
                    (this.data_detail = {
                        invoice: '',
                        nama_pelanggan: '',
                        bill_periode: '',
                        bill_tagihan: '',
                        bill_total_tagihan: '',
                        bill_fee: '',
                        bill_total_bayar: '',
                        bill_detail: '',
                        biaya_outlet: '',
                        jumlah_bayar: '',
                    });
            },
            checkInquiryBill() {
                this.countInquiry = this.countInquiry + 1;
                if (
                    this.detail_tagihan == false &&
                    this.loadingContentProduct == true &&
                    this.countInquiry <= 5
                ) {
                    $axios
                        .get(
                            '/transaction/pascabayar/' +
                                this.data_detail.invoice
                        )
                        .then(response => {
                            if (response.data.data.nama_pelanggan != null) {
                                this.detail_tagihan = true;
                                this.loadingContentProduct = false;
                                this.data_detail = {
                                    invoice: response.data.data.bill_invoice,
                                    nama_pelanggan:
                                        response.data.data.nama_pelanggan,
                                    bill_periode:
                                        response.data.data.bill_periode.split(
                                            ','
                                        ).length,
                                    bill_tagihan:
                                        response.data.data.bill_tagihan,
                                    bill_admin: response.data.data.bill_admin,
                                    bill_total_tagihan:
                                        response.data.data.bill_total_tagihan,
                                    bill_fee: response.data.data.bill_fee,
                                    bill_total_bayar:
                                        response.data.data.bill_total_bayar,
                                    bill_detail: JSON.parse(
                                        response.data.data.bill_detail
                                    ),
                                };
                            } else {
                                setTimeout(() => this.checkInquiryBill(), 3000);
                            }
                        })
                        .catch(e => {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                position: 'top',
                            });
                            this.loadingContentProduct = false;
                        });
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message:
                            'Tagihan tidak tersedia, silahkan hubungi Admin',
                        tipe: 'default',
                        position: 'top',
                    });
                    this.loadingContentProduct = false;
                }
            },
            checkbill(product_id) {
                this.countInquiry = 0;
                this.$store.commit('RESET_TOAST');
                this.detail_tagihan = false;
                this.loadingContentProduct = true;
                this.data_form.product_id = product_id;
                if (this.data_form.no_pelanggan != '') {
                    $axios
                        .post('/pascabayar/checkbill', {
                            product_id: this.data_form.product_id,
                            no_pelanggan: this.data_form.no_pelanggan,
                            biaya_outlet: this.data_form.outlet,
                        })
                        .then(response => {
                            this.data_detail.invoice =
                                response.data.data.invoice;
                            if (
                                response.data.data.nama_pelanggan != undefined
                            ) {
                                this.detail_tagihan = true;
                                this.loadingContentProduct = false;
                                this.data_detail = {
                                    invoice: response.data.data.invoice,
                                    nama_pelanggan:
                                        response.data.data.nama_pelanggan,
                                    bill_periode:
                                        response.data.data.periode.split(',')
                                            .length,
                                    bill_tagihan:
                                        response.data.data.jumlah_tagihan,
                                    bill_admin: response.data.data.biaya_admin,
                                    bill_total_tagihan:
                                        response.data.data.total_tagihan,
                                    bill_fee: response.data.data.fee,
                                    bill_total_bayar:
                                        response.data.data.total_bayar,
                                    bill_detail: response.data.data.detail,
                                    biaya_outlet:
                                        response.data.data.biaya_outlet,
                                    jumlah_bayar:
                                        response.data.data.jumlah_bayar,
                                };
                            } else {
                                this.checkInquiryBill();
                            }
                        })
                        .catch(e => {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.data.description,
                                tipe: 'default',
                                position: 'top',
                                icon: 'danger',
                            });
                            this.loadingContentProduct = false;
                        });
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: 'No. Pelanggan tidak boleh kosong',
                        tipe: 'default',
                        position: 'top',
                        icon: 'danger',
                    });
                    this.loadingContentProduct = false;
                }
            },
            confirmation() {
                this.$store.commit('RESET_TOAST');
                let element = this.$refs.confirmation.$el;
                window.$(element).modal('show');
            },
            hideConfirm() {
                this.data_form.pin = '';
                let element = this.$refs.confirmation.$el;
                window.$(element).modal('hide');
            },
            status(value) {
                let element = this.$refs.status.$el;
                window.$(element).modal(value);
            },
            submit() {
                this.loadingButton = true;
                $axios
                    .post('/pascabayar/paybill', {
                        invoice: this.data_detail.invoice,
                        pin: this.data_form.pin,
                    })
                    .then(() => {
                        this.loadingButton = false;
                        this.hideConfirm();
                        this.status('show');
                        this.clearData();
                        this.data_form.no_pelanggan = '';
                        this.data_form.admin = '2000';
                    })
                    .catch(e => {
                        this.hideConfirm();
                        this.loadingButton = false;
                        if (
                            e.response.status == 400 &&
                            e.response.data.responseCode == 'AVAILABLE_UPDATE'
                        ) {
                            this.dialogUpdateAPK('show');
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'danger',
                                position: 'top',
                                icon: 'danger',
                            });
                        }
                    });
            },
            phone(phone) {
                this.data_form.no_pelanggan = this.$options.filters.filterPhone(
                    this.$options.filters.filterPhone(
                        phone.substring(0, 3),
                        ['+62', '62'],
                        ['0', '0']
                    ) + phone.substring(20, 3),
                    ['-'],
                    ['']
                );
            },
            openPhoneBook() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openPhoneBook();
                }
            },
        },
        mounted() {
            if (this.title == undefined) {
                this.$router.push({ name: 'home' });
            }

            window['phone'] = phone => {
                this.phone(phone);
            };
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
        filters: {
            filterPhone: function (value, findArray, replaceArray) {
                var i,
                    regex = [],
                    map = {};
                for (i = 0; i < findArray.length; i++) {
                    regex.push(
                        findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1')
                    );
                    map[findArray[i]] = replaceArray[i];
                }
                regex = regex.join('|');
                var destination = value.replace(
                    new RegExp(regex, 'g'),
                    function (matched) {
                        return map[matched];
                    }
                );
                return destination.replace(/ /g, '');
            },
        },
    };
</script>
